import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import AuthLayout from "./AuthLayout";
import Field from "./components/Field";
import Button from "./components/Button";
import Stack from "./components/Stack";
import { login } from "./api";

const storeSession = (token, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user_id", user.user_id);
  localStorage.setItem("username", user.username);
  localStorage.setItem("email", user.email);
  localStorage.setItem("userphone", user.u_phoneno);
  localStorage.setItem("usertype", user.user_type);
  localStorage.setItem("isvisible", user.user_type === "SP" ? "visible" : "invisible");
  localStorage.setItem("userlogged", "visible");
};

export default function Login() {
  const history = useHistory();
  const [uname, setuname] = useState("");
  const [pwd, setpwd] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await login(uname, pwd);
      storeSession(res.data.token, res.data.user);
      toast.success("Login successful!");
      history.push("/search");
    } catch (error) {
      toast.error("Login unsuccessful. Try again.");
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Log in to book trusted pros near you.">
      <form onSubmit={onSubmit}>
        <Stack gap="5">
          <Field id="uname" label="Username" value={uname}
                 onChange={(e) => setuname(e.target.value)} autoComplete="username" required />
          <Field id="pwd" label="Password" type="password" value={pwd}
                 onChange={(e) => setpwd(e.target.value)} autoComplete="current-password" required />
          <Button type="submit">Log in</Button>
          <Button type="button" variant="secondary" onClick={() => history.push("/register")}>
            New here? Create an account
          </Button>
        </Stack>
      </form>
    </AuthLayout>
  );
}
